import { Box, Typography, styled } from '@mui/material';
import { currency } from '@shared/hooks/currencies';

const StyledTypographyLabel = styled(Typography)(({ $bold }) => ({
  fontWeight: $bold ? 700 : 400,
  display: 'inline',
  color: '#000',
}));

const BookingSummaryRow = ({
  label,
  value,
  labelBold = true,
  valueBold = false,
}) => (
  <Typography sx={{ color: '#000' }}>
    <StyledTypographyLabel component="span" $bold={labelBold}>
      {label}:
    </StyledTypographyLabel>{' '}
    <StyledTypographyLabel component="span" $bold={valueBold}>
      {value}
    </StyledTypographyLabel>
  </Typography>
);

export const BookingSummaryText = PNR => {
  if (!PNR?.pnr_data || !PNR.cluster) return null;

  const code = PNR?.PNR_code || '---';
  const estado = 'Pendiente / Reserva temporal';
  const carrier =
    PNR?.cluster?.carrier?.description || 'Aerolínea no especificada';

  let tipoViaje;

  const legsLength = PNR?.cluster?.legs?.length || 0;

  if (legsLength > 2) {
    tipoViaje = 'Multidestino';
  } else if (legsLength > 1) {
    tipoViaje = 'Ida y vuelta';
  } else {
    tipoViaje = 'Solo ida';
  }

  const total = PNR?.cluster?.composition_price?.total || 0;

  const totalFormatted = currency(total);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <BookingSummaryRow
        label="Tu reserva quedó registrada con el código"
        value={code}
        labelBold={false}
        valueBold={true}
      />

      <BookingSummaryRow label="Estado" value={estado} />
      <BookingSummaryRow label="Resultado" value={carrier} />
      <BookingSummaryRow label="Tipo de viaje" value={tipoViaje} />
      <BookingSummaryRow label="Total" value={totalFormatted} />

      <Typography sx={{ mt: 1, color: '#000' }}>
        Para finalizar tu compra, por favor comunícate con nuestros vendedores.
      </Typography>
    </Box>
  );
};
